<template>
  <div class="right-wrap">
    <router-link :to="{ name: 'shopping-cart' }">
      <i class="el-icon el-icon-cart"></i>
      <div>购</div>
      <div>物</div>
      <div>车</div>
      <div class="badge">
        {{ $store.state.total > 99 ? "99+" : $store.state.total }}
      </div>
    </router-link>
    <router-link :to="{ name: 'order-list' }">
      <i class="el-icon el-icon-order"></i>
      <p>我的订单</p>
    </router-link>
    <router-link :to="{ name: 'user-center' }">
      <i class="el-icon el-icon-person"></i>
      <p>个人中心</p>
    </router-link>
    <a>
      <i class="el-icon el-icon-tel"></i>
      <p class="tel-txt">客服电话 400-088-8635</p>
    </a>
    <a @click="toKf">
      <i class="el-icon iconpclianxikefu"></i>
      <p>在线客服</p>
    </a>
    <a>
      <i class="el-icon el-icon-code">
        <p class="code">
          <img src="../assets/images/code.png" alt />
        </p>
      </i>
    </a>
    <a @click="change">
      <img src="../assets/images/changeLen.png" class="changeIcon" alt />
    </a>
    <a @click="goTop">
      <i class="el-icon-arrow-up"></i>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cartNumber: 0
    };
  },
  methods: {
    toKf() {
      this.$reqGet("/api/store/udesk/userPage").then(res => {
        if (res.data.success) {
          window.open(res.data.data.url);
        }
      });
    },
    goTop() {
      window.scrollTo(0, 0);
    },
    change() {
      var documentDome = document.getElementById("ytWidget");
      if (documentDome) {
        documentDome.parentNode.removeChild(documentDome);
      } else {
        const loading = this.$loading({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
        this.$bus.emit("loadsTop");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.right-wrap {
  position: fixed;
  right: 20px;
  top: 20%;
  text-align: center;
  display: flex;
  flex-direction: column;
  z-index: 2000;
  i {
    font-size: 20px;
    border-radius: 3px;
    color: #fff;
  }
  a {
    position: relative;
    padding: 5px;
    border-top: 1px solid #838383;
    border-radius: 5px;
    color: #fff;
    margin: 1px auto;
    margin-bottom: 1px;
    background: rgba(98, 98, 98, 1);
    &:last-child {
      border-bottom: 1px solid #838383;
    }
    .el-icon-cart {
      font-size: 18px;
    }

    &:hover {
      background-color: #55c3fd;
      border-color: #55c3fd;
    }
    &:hover p {
      display: block;
      animation: fadeIn 0.5s;
    }
    &:hover .tel-txt {
      animation: fadeInTel 0.5s;
    }

    p {
      display: none;
      position: absolute;
      right: 0px;
      top: -14px;
      z-index: -1;
      width: 86px;
      padding: 5px;
      text-align: left;
      padding-left: 10px;
      background-color: #55c3fd;
      border-radius: 5px;
      white-space: nowrap;
      img {
        position: absolute;
        width: 80px;
        left: -30px;
        right: 100px;
        bottom: -84px;
        padding: 10px;
        background-color: #55c3fd;
        border-radius: 5px;
      }
    }
    .tel-txt {
      width: 190px;
    }
    .badge {
      width: 30px;
      height: 30px;
      background: #f30018;
      border-radius: 50%;
      font-size: 13px;
      transform: scale(0.8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
@keyframes fadeIn {
  from {
    width: 0;
  }
  to {
    width: 86px;
  }
}
@keyframes fadeInTel {
  from {
    width: 0;
  }
  to {
    width: 190px;
  }
}
.right-wrap /deep/ .el-badge__content {
  border: none;
  background-color: #fc0010;
  padding: 3px 6px;
  border-radius: 50%;
}
.changeIcon {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/right-nav.vue